import { Item, SubsystemsResponseDTO } from '@dto/architecture.dto';
import { SelectProps } from 'antd/es/select';
import axios, { AxiosError } from 'axios';
import { useContext, useEffect, useState } from 'react';
import { isClassLPAR } from 'src/data/Class';
import { Log } from 'src/service/log.service';
import { AdditionalApiPropsContext, ruleHwType } from '../XmRule';

export interface Option {
  hwType?: string;
  label: string;
  value: string;
  items: Item[];
};

type OptionType = SelectProps<string, Option>['options'];
const useParentTypes = (cls: string, subsystem: string, hwType?: string): [OptionType, boolean] => {
  const [parents, setParents] = useState<OptionType>([]);
  const [loading, setLoading] = useState(false);
  const { parents: parentsParams } = useContext(AdditionalApiPropsContext);

  useEffect(() => {
    if (!subsystem || isClassLPAR(cls) && !hwType)
      return;

    //from v2.4 hwType added for LAN
    if (!ruleHwType(cls, hwType)) {
      setLoading(true);
      const controller = new AbortController();
      axios.get<SubsystemsResponseDTO>(`/api/architecture/v1/classes/${cls}/subsystems/${subsystem}/parents`, { signal: controller.signal }).then(
        ({ data: { data } }) => {
          if (data.length)
            setParents(data.map(({ subsystem, label, items }) => ({ label, value: subsystem, items })));
          else
            setParents([]);
        },
        (reason: AxiosError) => Log.error('Failed to get parent list', reason)
      ).finally(() => setLoading(false));

      return () => controller.abort();
    }

    setLoading(true);
    const controller = new AbortController();
    const params = parentsParams?.type ? { ...parentsParams.type } : {};
    axios.get<SubsystemsResponseDTO>(`/api/architecture/v1/hw_types/${hwType}/subsystems/${subsystem}/parents`, { signal: controller.signal, params }).then(
      ({ data: { data } }) => setParents(data.map(({ subsystem, label, hw_type, items }): Option => ({ label, value: subsystem, hwType: hw_type, items }))),
      reason => Log.error('Failed to get parent list', reason)
    ).finally(() => setLoading(false));

    return () => controller.abort();
  }, [hwType, subsystem]);

  return [parents, loading];
};

export default useParentTypes;